import { render, staticRenderFns } from "./DxAttachmentTable.vue?vue&type=template&id=5045e362&"
import script from "./DxAttachmentTable.vue?vue&type=script&lang=js&"
export * from "./DxAttachmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports